import CrmCenteredTitle from '../../components/CrmCenteredTitle';
import React, { useEffect } from 'react';
import CrmLayout from '../../components/CrmLayout';
import { useMutation, useQuery } from '@apollo/client';
import { MUTATION_UPDATE_PROJECT, QUERY_PROJECT } from '../../graphql/project';
import { message, Skeleton } from 'antd';
import { NOT_FOUND } from '../../routes';
import { useNavigate } from 'react-router-dom';
import ProjectForm from './ProjectForm';
import _ from 'lodash';
import { normaliseColor } from '../../helpers/color';

export default function ProjectEdit(props) {

    const navigate = useNavigate();

    const query = useQuery(QUERY_PROJECT, {
        variables: {
            id: props.id,
        },
    })
    const [updateProject, { loading }] = useMutation(MUTATION_UPDATE_PROJECT)

    useEffect(() => {
        if (query.data?.project?.data === null) {
            navigate(NOT_FOUND)
        }
    }, [navigate, query.data?.project?.data])

    const onFinish = async (input) => {
        const data = {
            ...input,
            logo: input.logo ? input.logo.id : undefined,
            cover: input.cover ? input.cover.id : undefined,
            color: normaliseColor(input.color),
            levels: _.map(input.levels, (level) => ({
                ...level,
                color: normaliseColor(level.color),
            })),
        }
        await updateProject({
            variables: {
                id: props.id,
                data: data,
            },
            onCompleted: () => {
                query.refetch()
                message.success('Сохранили успешно')
            }
        })
    }

    return (
        <CrmLayout>

            <CrmCenteredTitle title={query.data?.project?.data?.attributes?.name}/>

            {query.loading && <Skeleton active/>}

            {query.data?.project?.data &&
                <ProjectForm edit
                             loading={loading}
                             initialValues={{
                    ...query.data?.project?.data?.attributes,
                    logo: query.data?.project?.data?.attributes?.logo?.data ? {
                        id: query.data?.project?.data?.attributes?.logo.data.id,
                        url: query.data?.project?.data?.attributes?.logo.data.attributes.url,
                    } : undefined,
                    cover: query.data?.project?.data?.attributes?.cover?.data ? {
                        id: query.data?.project?.data?.attributes?.cover.data.id,
                        url: query.data?.project?.data?.attributes?.cover.data.attributes.url,
                    } : undefined,
                }}
                             onFinish={onFinish}
                />
            }

        </CrmLayout>
    )
}